<div
  class="flex flex-col items-center justify-between md:h-[544px] md:px-10 xl:w-[1300px]"
>
  <div
    class="flex flex-1 flex-col items-center justify-center text-center md:gap-10"
  >
    <div class="mx-auto flex max-w-[500px] flex-col gap-4">
      <h2 class="text-primary-900">
        {{ "prestations.addPrestation" | transloco }}
      </h2>
      <p class="text-paragraph-s-reg">
        {{ "prestations.addPrestationText" | transloco }}
      </p>
    </div>
    <div class="flex flex-col items-center justify-center gap-6 md:flex-row">
      <button
        class="flex h-[188px] w-[221px] flex-col gap-2 rounded-lg p-4 shadow-lg"
        (click)="prestationModalService.addTransport()"
      >
        <div class="m-auto rounded-full bg-primary-50 p-4 text-primary-500">
          <lucide-icon name="car" [size]="32" />
        </div>
        <h4>{{ "calculator.addTransport" | transloco }}</h4>
        <p class="text-paragraph-s-reg text-greyscale-700">
          {{ "calculator.addTransportText" | transloco }}
        </p>
      </button>
      <button
        class="flex h-[188px] w-[221px] flex-col gap-2 rounded-lg p-4 shadow-lg"
        (click)="prestationModalService.addAccommodation()"
      >
        <div class="m-auto rounded-full bg-primary-50 p-4 text-primary-500">
          <lucide-icon name="house-plus" [size]="32" />
        </div>
        <h4>{{ "calculator.addAccommodation" | transloco }}</h4>
        <p class="text-paragraph-s-reg text-greyscale-700">
          {{ "calculator.addAccommodationText" | transloco }}
        </p>
      </button>
      <button
        class="flex h-[188px] w-[221px] flex-col gap-2 rounded-lg p-4 shadow-lg"
        (click)="prestationModalService.addActivity()"
      >
        <div class="m-auto rounded-full bg-primary-50 p-4 text-primary-500">
          <lucide-icon name="bike" [size]="32" />
        </div>
        <h4>{{ "calculator.addActivity" | transloco }}</h4>
        <p class="text-paragraph-s-reg text-greyscale-700">
          {{ "calculator.addActivityText" | transloco }}
        </p>
      </button>
    </div>
  </div>

  <div class="flex w-full items-end justify-end">
    <p-button
      [label]="'close' | transloco"
      (click)="prestationModalService.close()"
      severity="secondary"
      [text]="true"
    />
  </div>
</div>
